type Listener = (id: string, actor: 'local' | 'remote') => void;
const listeners = new Set<Listener>();

export function onDocDeleted(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function fireDocDeleted(id: string, actor: 'local' | 'remote'): void {
  listeners.forEach((fn) => fn(id, actor));
}
